export const MENTEE_LESSON_STATUSES = {
  inactive: 'inactive',
  active: 'active',
  archived: 'archived',
  bonus: 'bonus',
  locked: 'locked',
  repeat: 'repeat',
  recording: 'recording',
  crashCourse: 'crash_course',
};
